"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCcSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M22.213 2A1.79 1.79 0 0124 3.787v16.34a1.79 1.79 0 01-1.787 1.788H1.787A1.79 1.79 0 010 20.128V3.788A1.79 1.79 0 011.787 2zM7.908 8.128c-1.56 0-2.802 1.334-2.802 2.954v1.75l.005.18c.088 1.538 1.295 2.775 2.797 2.775.984 0 1.876-.538 2.38-1.393a.766.766 0 10-1.318-.78c-.236.4-.635.641-1.062.641-.688 0-1.27-.625-1.27-1.422v-1.75l.007-.148c.066-.726.618-1.275 1.263-1.275.428 0 .826.24 1.063.642l.059.086a.766.766 0 001.26-.866c-.506-.856-1.397-1.394-2.382-1.394zm8.17 0c-1.56 0-2.802 1.334-2.802 2.954v1.75l.005.18c.088 1.538 1.295 2.775 2.798 2.775.983 0 1.875-.538 2.38-1.393a.766.766 0 00-1.32-.78c-.235.4-.634.641-1.06.641-.69 0-1.27-.625-1.27-1.422v-1.75l.006-.148c.066-.726.618-1.275 1.264-1.275.427 0 .825.24 1.062.642l.059.086a.766.766 0 001.26-.866c-.506-.856-1.397-1.394-2.381-1.394z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCcSolid;
exports.default = _default;